<template>
  <div :style="`height: ${contentHeight};`" class="pa-4 overflow--y">
    <div v-if="hasRole('project', 'ROLE_GET_PROJECT_ID')">
      <h2 class="container__title mb-3">{{ data.name || '-' }}</h2>

      <div class="mb-2">
        <div class="item__label">{{ $t(`Common.costCenter`) }}</div>
        <div v-if="isValidArray(data.costCenters)">
          <span v-for="(item, index) in data.costCenters" :key="index">
            <a
              v-if="claims.costCenter['ROLE_GET_COSTCENTER_ID']"
              class="accent--text"
              @click.prevent="change(
                {
                  type: 'costCenter',
                  action: null
                },
                {
                  id: item.id,
                  name: item.name
                }
              )"
            >
              {{ item.name.trim() }}<span v-if="index !== (data.costCenters.length - 1)">, </span>
            </a>

            <span v-else>
              {{ item.name.trim() }}<span v-if="index !== (data.costCenters.length - 1)">, </span>
            </span>
          </span>
        </div>

        <div v-else-if="claims.project['ROLE_PUT_PROJECT_ID']">
          <a class="accent--text" @click="handleEditProject">
            {{ $t(`${namespace}.addCostCenter`) }}
          </a>
        </div>

        <div v-else>N/A</div>
      </div>

      <div class="mb-2">
        <div class="item__label text-capitalize">{{ $t(`Common.company`) }}</div>
        <div v-if="data.company && data.company.name">{{ data.company.name }}</div>
        <div v-else>N/A</div>
      </div>
    </div>

    <EmptyState
      v-else
      image="employee"
      :imageSize="120"
      class="px-4"
    >
      <span class="state__text">{{ $t('Views.ReportsPage.withoutPermission') }}</span>
    </EmptyState>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole, isArray, calcContentHeight } from 'utils/functions'
import EmptyState from 'components/EmptyState'

export default {
  name: 'Preview',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    EmptyState
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.project.preview',
      contentHeight: 'none'
    }
  },
  methods: {
    isValidArray (val) {
      return isArray(val)
    },

    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = `${calcContentHeight()}px`
    },

    handleEditProject () {
      this.$emit('toggleAction', 'edit')
    },

    change (drawer, data) {
      this.$emit('change', {
        drawer: {
          type: drawer.type,
          action: drawer.action
        },
        data: {
          id: data.id,
          name: data.name
        }
      })
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.container__title {
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 800;
}
</style>
